import React from 'react'
import "./TransactionValue.css";
import { ResponsiveContainer } from 'recharts';
import { YAxis, XAxis, AreaChart, Area } from 'recharts';
import {highest} from '../../../../Utilt/EstimateHighest.js';
import { nFormatter } from '../../../../APIs/Metrics/Metrics';

const TransactionValue = ({ transCount = null }) => {
  return (
    <div className='transacted-value'>
      <p>Transaction value</p>
      <div className='' style={{ height: "200px", marginLeft: "10px", paddingTop: "20px" }}>

        {(transCount !== null && transCount.length>0) && <ResponsiveContainer width="100%" height={180}>

          <AreaChart data={transCount}>

            <YAxis tickFormatter={nFormatter} allowDecimals={false} dataKey="in" domain={[0, highest(transCount)+10]} tickSize={22} tickLine={false} axisLine={false} padding={{ bottom: 0 }}
              style={{ fontSize: "10px", }}
            />
            <Area type="monotone" dataKey="in" stroke="#E0FFE9" fill="#E0FFE9" />
            <XAxis interval={Math.floor(transCount / 9)} angle={0} tick={{ stroke: 'rgb(125, 123, 123)', strokeWidth: 0.3 }} dx={10} dy={8} dataKey="date" tickLine={false} padding={{ left: 0, right: 20 }} tickSize={10} allowDataOverflow={true} minTickGap={30} style={{ backgroundColor: "#fff", fontSize: "10px", zIndex: "2" }} />

          </AreaChart>

        </ResponsiveContainer>}

      </div>

      
      <div className='' style={{ height: "200px", marginTop:"-220px", marginLeft: "10px", paddingTop: "20px" }}>

        {(transCount !== null && transCount.length>0) && <ResponsiveContainer width="100%" height={180}>

          <AreaChart data={transCount}>

            <YAxis tickFormatter={nFormatter} allowDecimals={false} dataKey="out" domain={[0, highest(transCount)+10]}  tickSize={22} tickLine={false} axisLine={false} padding={{ bottom: 0 }}
              style={{ fontSize: "10px", }}
            />
            <Area type="monotone" dataKey="out" stroke="#FF9A8C" fill="#FF9A8C" />
            <XAxis interval={Math.floor(transCount / 9)} angle={0} tick={{ stroke: 'rgb(125, 123, 123)', strokeWidth: 0.3 }} dx={10} dy={8} dataKey="date" tickLine={false} padding={{ left: 0, right: 20 }} tickSize={10} allowDataOverflow={true} minTickGap={30} style={{ backgroundColor: "#fff", fontSize: "10px", zIndex: "2" }} />

          </AreaChart>

        </ResponsiveContainer>}

      </div>
    </div>
  )
}

export default TransactionValue